import { LedgerStateContext } from "@/features/ledgersAll/context/LedgerProvider";
import { useContext } from "react";

export function useLedgersState() {
  const value = useContext(LedgerStateContext);
  if (value === undefined) {
    throw new Error("useLedgersState should be used within LedgerProvider");
  }
  return value;
}
